import TextFieldValidation from '@components/TextFieldValidation/TextFieldValidation';
import { Grid } from '@mui/material';
import React, { FC } from 'react';
import { CONNECTORS_FORM_KEYS, IConnectorEditDialog } from 'types/connectors';

const locale = {
	serviceName: `connectors.edit.dialog.form.field.serviceName`,
	apiKey: `connectors.edit.dialog.form.field.apiKey`,
	fromEmail: `connectors.edit.dialog.form.field.fromEmail`
};

const SendgridEditForm: FC<IConnectorEditDialog> = ({
	gridSpacing,
	formik
}) => (
	<Grid
		container
		spacing={gridSpacing}
		data-testid="connector-edit-dialog-sendgrid"
	>
		<Grid item xs={12}>
			<TextFieldValidation
				autoFocus
				id={CONNECTORS_FORM_KEYS.serviceName}
				type="text"
				required
				formik={formik}
				label={intl.tr(locale.serviceName)}
				fullWidth
			/>
		</Grid>
		<Grid item container spacing={gridSpacing}>
			<Grid item xs={12}>
				<TextFieldValidation
					id={CONNECTORS_FORM_KEYS.apiKey}
					type="password"
					required
					formik={formik}
					label={intl.tr(locale.apiKey)}
					fullWidth
				/>
			</Grid>
		</Grid>
		<Grid item xs={12}>
			<TextFieldValidation
				id={CONNECTORS_FORM_KEYS.fromEmail}
				type="email"
				required
				formik={formik}
				label={intl.tr(locale.fromEmail)}
				fullWidth
			/>
		</Grid>
	</Grid>
);

export default SendgridEditForm;
